import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import { apiService } from '@/services'
import { FeatureFlag, useHasFeature } from '@/composables/useHasFeature/useHasFeature'
import type { Video, VideoDraftItem } from '@/services/videos/types'

export function useDownloadVideo() {
  const store = useStore()
  const { t } = useI18n()
  const isDownloading = ref(false)

  const canDownload = computed<boolean>(() =>
    useHasFeature(FeatureFlag.AllowAiDownload, store.state.user.features ?? [])
  )

  async function download(video: Video | VideoDraftItem) {
    if (isDownloading.value) return
    isDownloading.value = true
    try {
      const { url } = await apiService.videos.downloadVideo(video.video_id)
      window.location.assign(url)
    } catch (err) {
      store.dispatch('messages/addMessage', {
        message: t('ai-video-download-failed'),
        type: 'fail'
      })
    } finally {
      isDownloading.value = false
    }
  }

  return { isDownloading, canDownload, download }
}
